import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, RefreshCw, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ErrorFallbackPageProps {
  error?: Error;
  routeName?: string;
  onReset?: () => void;
}

const ErrorFallbackPage: React.FC<ErrorFallbackPageProps> = ({ 
  error, 
  routeName,
  onReset 
}) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleRetry = () => {
    if (onReset) {
      onReset();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted flex items-center justify-center p-4">
      <div className="max-w-lg w-full bg-card border border-border rounded-xl shadow-lg p-8 text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">⚠️</span>
          </div>
          <h1 className="text-2xl font-bold mb-2">Une erreur est survenue</h1>
          {routeName && (
            <p className="text-sm text-muted-foreground">
              Page : {routeName}
            </p>
          )}
        </div>

        <div className="bg-muted/50 rounded-lg p-4 mb-6 text-left">
          <p className="text-sm text-muted-foreground mb-2">
            Détails techniques :
          </p>
          <code className="text-xs text-foreground break-all">
            {error?.message || 'Erreur inconnue'}
          </code>
        </div>

        <div className="space-y-3">
          <Button 
            onClick={handleGoHome}
            className="w-full"
            variant="default"
          >
            <Home className="mr-2 h-4 w-4" />
            Retour à l'accueil
          </Button>

          <Button 
            onClick={handleRetry}
            className="w-full"
            variant="outline"
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Réessayer
          </Button>

          <Button 
            onClick={() => window.location.href = 'mailto:support@example.com'}
            className="w-full"
            variant="ghost"
          >
            <Mail className="mr-2 h-4 w-4" />
            Contacter le support
          </Button>
        </div>

        <p className="text-xs text-muted-foreground mt-6">
          Cette erreur a été automatiquement signalée à notre équipe.
        </p>
      </div>
    </div>
  );
};

export default ErrorFallbackPage;
